import { render, staticRenderFns } from "./PictureCardUpload.vue?vue&type=template&id=0cb590a4&scoped=true"
import script from "./PictureCardUpload.vue?vue&type=script&lang=js"
export * from "./PictureCardUpload.vue?vue&type=script&lang=js"
import style0 from "./PictureCardUpload.vue?vue&type=style&index=0&id=0cb590a4&prod&lang=less&scoped=true"
import style1 from "./PictureCardUpload.vue?vue&type=style&index=1&id=0cb590a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb590a4",
  null
  
)

export default component.exports